import { render, staticRenderFns } from "./QuestionWrongTrendMobile.vue?vue&type=template&id=5512bc2a&scoped=true"
import script from "./QuestionWrongTrendMobile.vue?vue&type=script&lang=js"
export * from "./QuestionWrongTrendMobile.vue?vue&type=script&lang=js"
import style0 from "./QuestionWrongTrendMobile.vue?vue&type=style&index=0&id=5512bc2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512bc2a",
  null
  
)

export default component.exports